import { Const } from '../../../../shared/const';
import { DEFAULT_TINYMCE_OPTIONS } from '../../../../shared/default-tinymce-options';

export const FOD_DEFAULT_TINYMCE_OPTIONS = {
    ...DEFAULT_TINYMCE_OPTIONS,

    selector: '#tinyMce',
    content_css: '/assets/css/fod-default-tinymce.css',

    plugins: [
        'searchreplace',
        'code',
        'link'
    ],

    toolbar1: 'blocks fontsizeinput | searchreplace | charmap subscript superscript | removeformat | code | link',
    toolbar2: 'bold italic underline | forecolor backcolor | bullist numlist | undo redo | visualchars visualblocks | vEDocs',
    //toolbar1: 'fontsizeinput | searchreplace | code fullscreen',
    //toolbar1: 'blocks fontsizeinput | outdent indent | searchreplace | charmap subscript superscript | removeformat',
    //toolbar2: 'bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | table | undo redo | visualchars visualblocks | code fullscreen',
    //toolbar3: 'pdfPreview | vPessoas vLocais vDatas vForm',

    setup: editor => {
        editor.ui.registry.addMenuButton('vEDocs', {
            text: 'Adicionar Protocolo E-Docs',
            fetch: callback => callback([
                {
                    type: 'nestedmenuitem',
                    text: 'Encaminhamento',
                    getSubmenuItems: () => [
                        {
                            type: 'menuitem',
                            text: 'Protocolo',
                            onAction: () => editor.insertContent(Const.TagPublicMessageForwardingProtocol)
                        },
                        {
                            type: 'menuitem',
                            text: 'Link com protocolo para o E-Docs',
                            onAction: () => editor.insertContent(Const.TagPublicMessageForwardingLink)
                        }
                    ]
                },
                {
                    type: 'nestedmenuitem',
                    text: 'Processo',
                    getSubmenuItems: () => [
                        {
                            type: 'menuitem',
                            text: 'Protocolo',
                            onAction: () => editor.insertContent(Const.TagPublicMessageProcessProtocol)
                        },
                        {
                            type: 'menuitem',
                            text: 'Link com protocolo para o E-Docs',
                            onAction: () => editor.insertContent(Const.TagPublicMessageProcessLink)
                        }
                    ]
                }
            ])
        });
    }
};
